import React from "react";
import { FormSection } from "../../Form";

import uuid from "uuid/v4";
import TextField from "components/fields/text/TextField";
import IconButton from "components/IconButton";
import DatePicker from "../DatePicker";

//import PropTypes from 'prop-types';

const paramTypes = {
    dateIn: "date",
    dateOut: "date",
    weekStart: "dow",
    weekEnd: "dow",
};

const suggestedParams = [
    "nights",
    "minStay",
    "maxStay",
    "weekStart",
    "weekEnd",
    "dateIn",
    "dateOut",
    "priceGroup",
];

function DayOfWeek(props) {
    //value 1-7 a string list comma separated
    const { value, onChange } = props;
    const days = value ? value.split(",") : [];
    const change = (v) => {
        if (days.includes(v)) {
            onChange(days.filter((item) => item !== v).join(","));
        } else {
            onChange([...days, v].join(","));
        }
    };
    const names = {
        1: "Pn",
        2: "Wt",
        3: "Śr",
        4: "Cz",
        5: "Pt",
        6: "So",
        7: "Nd",
    };
    return (
        <div className={"dayofweek"}>
            {["1", "2", "3", "4", "5", "6", "7"].map((item) => (
                <div
                    key={item}
                    className={`option ${days.includes(item) ? "active" : ""}`}
                    onClick={() => change(item)}
                >
                    {names[item]}
                </div>
            ))}
        </div>
    );
}

function ParamValue(props) {
    const { onChange, label, value, type } = props;

    if (type === "date")
        return <DatePicker label={label} onChange={onChange} value={value} />;

    if (type === "dow") {
        return (
            <div className={"cols cols-middle"}>
                <DayOfWeek value={value} onChange={onChange} />
            </div>
        );
    }

    return (
        <TextField
            onChange={onChange}
            value={value}
            label={"Value"}
            size={"small"}
        />
    );
}

export function BookingParams(props) {
    const { value, onChange } = props;

    const add = () => {
        onChange([...value, { id: uuid(), from: null, to: null }]);
    };
    const change = (id, key, v) => {
        onChange(
            value.map((item) => (item.id === id ? { ...item, [key]: v } : item))
        );
    };
    const remove = (id) => {
        onChange(value.filter((item) => item.id !== id));
    };

    const addParam = (name) => {
        onChange([...value, { id: uuid(), name: name, value: null }]);
    };

    const availableParams = suggestedParams.filter(
        (item) => !value.find((v) => v.name === item)
    );

    return (
        <FormSection
            name={"Parametry rezerwacji"}
            action={
                <div className={"cols"}>
                    <IconButton icon={"mui-add"} onClick={add} />
                </div>
            }
        >
            <div className={"rows gap-sm"}>
                {value && value.length ? (
                    value.map((item, index) => (
                        <div className={"cols cols-middle grow gap-sm"}>
                            <div className={"cols cols-2 grow gap-xs"}>
                                <TextField
                                    onChange={(v) => change(item.id, "name", v)}
                                    value={item.name}
                                    label={"Name"}
                                    size={"small"}
                                />
                                <ParamValue
                                    type={paramTypes[item.name] || "text"}
                                    value={item.value}
                                    label={item.name}
                                    onChange={(v) =>
                                        change(item.id, "value", v)
                                    }
                                />
                            </div>
                            <IconButton
                                icon={"mui-close"}
                                onClick={() => remove(item.id)}
                            />
                        </div>
                    ))
                ) : (
                    <div className={"o-60"}>Nie określono parametrów</div>
                )}
                <div className={"param-tags"}>
                    {availableParams.map((item) => (
                        <div
                            className={"param-tag"}
                            onClick={() => addParam(item)}
                        >
                            {item}
                        </div>
                    ))}
                </div>
            </div>
        </FormSection>
    );
}

BookingParams.propTypes = {};

BookingParams.defaultProps = {};

export default BookingParams;
